import { render } from "./GanttIcon.vue?vue&type=template&id=47220410"
import script from "./GanttIcon.vue?vue&type=script&lang=js"
export * from "./GanttIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__